// extracted by mini-css-extract-plugin
module.exports = {"inputbox":"inputbox__1K1ou","memory":"memory__3m5Uk","label":"label__2aJXx","space":"space__34Er7"};